import axios from 'axios';

export async function getCoordinates(cityName) {

  const POLAND = ["PL"];
  const NEIGHBORS = ["SK", "CZ", "UA", "DE", "AT", "SI", "HU"];

  // 1️⃣ Szukamy w Polsce

 const cleanCityName = cityName?.trim()

 if(!cleanCityName || cleanCityName.length < 3) return null

  let res = await axios.get(
    `https://geocoding-api.open-meteo.com/v1/search?name=${encodeURIComponent(cleanCityName)}&count=5&language=pl&format=json`
  );

  let result = res.data.results?.find(r => POLAND.includes(r.country_code));

  // 2️⃣ Szukamy w sąsiadach, jeśli nie ma w Polsce
  if (!result) {
    result = res.data.results?.find(r => NEIGHBORS.includes(r.country_code));
  }

  // 3️⃣ Fallback globalny, jeśli dalej nic
  if (!result && res.data.results?.length) {
    result = res.data.results[0];
  }

  if (!result) return null;

  return {
    lat: result.latitude,
    lon: result.longitude,
  };
}
